module.exports = __webpack_public_path__ + "img/x-circle.9b5f75c7.svg";